import { useQuery } from "@tanstack/react-query";
import { GeofencesService } from "../services/geofences.service";
import { GeofenceSearchParams } from "../domain/geofence.interface";

export const useGeofenceSearch = (
  params: GeofenceSearchParams,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: [
      "coyn-geofence-search",
      params.pageNumber,
      params.pageSize,
      params.sortField,
      params.sortOrder,
      params.search,
      params.action,
      params.addressType,
      params.programId,
      // COYN-1347: participant filter is part of the cache key so the
      // detail-map overlays don't show stale events from a previous
      // participant after navigating between geofence rows.
      params.participantId,
      params.dateFrom,
      params.dateTo,
      params.isPhantom,
    ],
    queryFn: () => GeofencesService.search(params),
    enabled: options?.enabled ?? true,
  });
};

export const useGeofenceById = (id: string) => {
  return useQuery({
    queryKey: ["coyn-geofence-by-id", id],
    queryFn: () => GeofencesService.findById(id),
    enabled: !!id,
  });
};
